export default __webpack_public_path__ + "static/media/dep.ca9d28cf.jpg";